export const state = {
    checkDomainShow: window.location.host.includes('hiaria') || window.location.host.includes('aria-indonesia'),
    hideLogoMceasy: !window.location.host.includes('sales-demo')
}